module.exports = __webpack_public_path__ + "img/motorway_8x2_z16.0e5e56fa.svg";